import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from 'src/app/services/language.service';
import { ConfirmationDialogData } from '../../modals/confirmation-dialog-data';
import { ConfirmationDialogComponent } from '../../modals/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { HttpService } from 'src/app/services/http.service';
import { AddRuleComponent } from '../add-rule/add-rule.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-start-rollout',
  templateUrl: './start-rollout.component.html',
  styleUrl: './start-rollout.component.scss',
  standalone: false
})
export class StartRolloutComponent {

  public releaseId: number = 0;
  public loading: boolean = false;
  private skipConfirmation: boolean = false;
  private filename: string = "";
  public softwareName: string = "";
  public componentName: string = "";

  @ViewChild('deactivationRule')
  deactivationRuleRef!: AddRuleComponent;

  deactivationInitValues: any;

  constructor(public languageService: LanguageService, private router: Router, private route: ActivatedRoute,
    private matDialog: MatDialog, private httpService: HttpService, private snackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.route.queryParams
      .subscribe(params => {
        if (params['id']==undefined){
          this.router.navigate(["/software-overview"]);
          return;
        }
        this.releaseId = params['id'];

        this.httpService.getReleaseList().subscribe((resp: any) => {
          this.loading = false;
          const actRelease = resp.data.find((el: any) => { return el.id == this.releaseId });
          this.filename = actRelease.release_component.filename;
          this.softwareName = actRelease.release_component.filename;
          this.componentName = actRelease.release_component.component_name;
        });
      });
  }

  ngAfterViewInit(): void {
    this.deactivationInitValues = this.deactivationRuleRef.getRules();
  }

  public onSubmit() {
    if (this.deactivationRuleRef.isValid()) {
      const data: ConfirmationDialogData = {
        title: this.languageService.languageJSON.StartApprovalRollout_SaveTitle,
        message: this.languageService.languageJSON.StartApprovalRollout_SaveDescription,
        buttons: [this.languageService.languageJSON.Global_Confirm, this.languageService.languageJSON.Global_Cancel]
      };

      this.matDialog.open(ConfirmationDialogComponent, { data: { data } }).afterClosed().subscribe((result) => {
        if (result) {
          this.loading = true;
          this.httpService.addDeactivationRules(this.releaseId, this.deactivationRuleRef.getRules()).subscribe((resp: any) => {
            if (resp?.success) {
              this.skipConfirmation = true;
              this.snackBar.open(this.languageService.languageJSON.ReleaseOverview_SoftwareRolloutStart.replace("$filename", this.filename),
                undefined, { panelClass: 'success-snackbar', duration: 8000 });
              this.loading = false;
              this.router.navigate(["/software-overview"]);
            }
            else {
              this.snackBar.open(this.languageService.languageJSON.Global_ServerError_Snackbar, undefined, { panelClass: 'success-snackbar', duration: 5000 });
            }
          });
        }
      });
    }
  }

  public isFormChanged(): boolean {
    if (JSON.stringify(this.deactivationRuleRef.getRules()) != JSON.stringify(this.deactivationInitValues)) {
      return true;
    }
    return false;
  }
}
